import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'wageapp_cookie_consent';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = useCallback(() => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  }, []);

  const handleDecline = useCallback(() => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: false,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent" role="dialog" aria-labelledby="cookie-title" aria-describedby="cookie-description">
      <div className="cookie-content">
        <h2 id="cookie-title" className="cookie-title">🍪 Cookie Notice</h2>
        <p id="cookie-description" className="cookie-text">
          This website uses only essential cookies that are necessary for the site to function. 
          We do not use tracking or advertising cookies. Your salary data is processed entirely 
          in your browser and is never stored or transmitted.
        </p>
        <p className="cookie-link">
          Read our <Link to="/privacy">Privacy Policy</Link> for more information.
        </p>
        <div className="cookie-buttons">
          <button 
            onClick={handleAccept} 
            className="cookie-btn accept"
            aria-label="Accept cookies"
          >
            Accept
          </button>
          <button 
            onClick={handleDecline} 
            className="cookie-btn decline"
            aria-label="Decline optional cookies"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
